package components.tableDateRange

import csstype.*
import csstype.ColorScheme.Companion.dark
import ics.materialUI.extensions.getKeys
import kotlinext.js.getOwnPropertyNames
import kotlinx.css.input
import kotlinx.js.Object
import kotlinx.js.jso
import mui.material.*
import mui.material.Size
import mui.system.sx
import org.w3c.dom.HTML
import org.w3c.dom.HTML.input
import org.w3c.dom.HTMLInputElement
import react.*
import react.dom.html.InputMode
import react.dom.html.InputType
import react.dom.onChange
import kotlin.js.Date
import kotlin.js.Json

val TableDateRangePickers = FC<TableDateRangePickersProps>("TableDateRangePickers") {props ->

    val handleCheckboxChange: () -> Unit = {
        if (props.checkBoxChecked != null && props.checkBoxChecked!!) {
            props.checkBoxCheckedSetter?.invoke(false)
            when {
                props.fromDate != null && props.endDate != null -> {
                    props.fromDateSetter(null)
                    props.endDateSetter(null)
                    props.dataSetter(null)
                }
                props.fromDate != null && props.endDate == null -> {
                    props.fromDateSetter(null)
                    props.dataSetter(null)
                }
                props.fromDate == null && props.endDate != null -> {
                    props.endDateSetter(null)
                    props.dataSetter(null)
                }
            }
        } else {
            props.checkBoxCheckedSetter?.invoke(true)
        }
    }

    val handleSetDate: (stateSetter: StateSetter<Date?>, value: Date) -> Unit = { stateSetter, value ->
        stateSetter(value)
        props.dataSetter(null)
    }

    // component generator functions
    val generateCheckBox = FormControlLabel.create {
        control = Checkbox.create {
            checked = props.checkBoxChecked?: false
            onChange = { _, _ ->
                handleCheckboxChange()
            }


        }
        label = ReactNode("Use date filters")

        sx {
            margin = 10.px
        }
    }

    val generateDateFields = arrayOf<ReactNode>(
        // start date
        TextField.create {
            type = InputType.date
            size = Size.small
            label = ReactNode("Start date")
            value = props.fromDate?.toISOString()?.slice(0..9) ?: ""
            InputLabelProps = jso {
                shrink = true
            }

            if (props.darkMode) {
                inputProps = jso {
                    style = jso {
                        this.colorScheme = dark
                    }
                }
            }

            onChange = {
                val newValue = it.target.unsafeCast<Json>()["value"].unsafeCast<String>()
                if (newValue.isNotEmpty())  handleSetDate(
                    props.fromDateSetter,
                    Date(Date.parse(newValue.plus("T00:00:01.001Z")))
                ) else props.fromDateSetter(null)
            }

            sx {
                marginRight = 10.px

                if (props.darkMode) colorScheme = dark
            }
        },
        // end date
        TextField.create {
            type = InputType.date
            size = Size.small
            label = ReactNode("End date")
            value = props.endDate?.toISOString()?.slice(0..9) ?: ""
            InputLabelProps = jso {
                shrink = true
            }
            if (props.darkMode) {
                inputProps = jso {
                    style = jso {
                        this.colorScheme = dark
                    }
                }
            }
            onChange = {
                val newValue = it.target.unsafeCast<Json>()["value"].unsafeCast<String>()
                if (newValue.isNotEmpty()) handleSetDate(
                    props.endDateSetter,
                    Date(Date.parse(newValue.plus("T23:59:59.999Z")))
                ) else props.endDateSetter(null)
            }

            sx {
                marginRight = 10.px


            }
        }
    )

    Box {
        sx {
            display = Display.inlineFlex
            flexDirection = FlexDirection.row
            alignContent = AlignContent.center
            alignItems = AlignItems.center
            width = Length.fitContent
        }

        if (props.checkboxFirst != null) {
            +generateCheckBox

            if (props.checkBoxChecked != null && props.checkBoxChecked!!) {
                generateDateFields.forEach { + it }
            }

        } else {
            generateDateFields.forEach { + it }
        }
    }


}